export default __webpack_public_path__ + "static/media/LOGO_OXETECH_WORK.32fc025c.svg";